module.exports = __webpack_public_path__ + "static/media/dog3.468e10ed.jpg";